// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iOGW","option":"styles_option__1KmS3","active":"styles_active__2X_Z0"};